import { render, staticRenderFns } from "./RocketHero.vue?vue&type=template&id=e9efd65c&scoped=true&"
import script from "./RocketHero.vue?vue&type=script&lang=js&"
export * from "./RocketHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9efd65c",
  null
  
)

export default component.exports